import { useEffect } from 'react';
import { useCEProductCustomization } from '../../bitf-customization-engine/useCEProductCustomization';
export function MoveProductToStore({
  storeName = 'shared',
  product,
  productVariant = null,
  watchStoreChanges = false,
}) {
  if (!product || !storeName) {
    return;
  }

  const { setStore } = useCEProductCustomization({
    storeName,
    watchStoreChanges,
  });

  useEffect(() => {
    setStore({
      currentProduct: product,
      currentProductVariant: productVariant,
    });
  }, [product, productVariant, setStore]);

  return null;
}
